import { HTMLAttributes, useRef } from "react";
import './index.scss'
import rm from "../../../utils/rm";

const Html = (prop: {
    html: string
} & HTMLAttributes<HTMLDivElement>) => {

    const wrapper = useRef<HTMLDivElement>();

    const html = prop.html.replace(/\<p\>\<\/p\>/g, "");

    return <div
        ref={(ref) => {
            wrapper.current = ref as HTMLDivElement
        }}
        {...prop}
        className={`html-render ${prop.className || ''}`}
        dangerouslySetInnerHTML={{ __html: html }}
        onClick={(e) => {
            if (e.target && (e.target as HTMLElement).tagName === 'IMG') {
                const url = (e.target as HTMLImageElement).getAttribute("src");
                if (url) {
                    const images = wrapper.current?.querySelectorAll("img") || [];
                    const imgUrls: string[] = [];
                    for (let index = 0; index < images.length; index++) {
                        const element = images[index];
                        if (element.hasAttribute("src"))
                            imgUrls.push(element.getAttribute("src") || '');
                    }
                    console.log({
                        url,
                        imgUrls
                    })
                    rm.previewImage({
                        url,
                        imgUrls
                    })
                }

            } else if (e.target && (e.target as HTMLElement).tagName === 'A') {
                e.preventDefault();
                e.stopPropagation();
                let href = (e.target as HTMLAnchorElement).getAttribute("href");

                if (href) {
                    if (href.indexOf("my.ruanmei.com/shop/") !== -1) {
                        href = "https://mall.ithome.com/?hidemenu=1&fitsystemWindow=1&keeptitle=1&isrmmp=1"
                    }
                    rm.navigateTo({
                        url: href
                    });
                }
            }
        }}
    >

    </div>
}

export default Html;